import {Location} from '@angular/common';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {LayoutService} from '../../../../_metronic/core';
import {UserRolesGuard} from '../../../../modules/auth/_services/user-roles.guard';
import {CurrentUserDataService} from '../../../../shared/_services/current-user-data.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-aside',
    templateUrl: './aside.component.html',
    styleUrls: ['./aside.component.scss'],
    providers: [UserRolesGuard]
})
export class AsideComponent implements OnInit, OnDestroy {
    disableAsideSelfDisplay: boolean;
    headerLogo: string;
    brandSkin: string;
    ulCSSClasses: string;
    location: Location;
    asideMenuHTMLAttributes: any = {};
    asideMenuCSSClasses: string;
    asideMenuDropdown;
    brandClasses: string;
    asideMenuScroll = 1;
    asideSelfMinimizeToggle = false;


    userRolesList = undefined;

    // Unsubscribe
    private unsubscribe: Subscription[] = [];


    constructor(private layout: LayoutService,
                private loc: Location,
                public userRollsChecker: CurrentUserDataService) {
    }

    ngOnInit(): void {


        this.getUser();


        // load view settings
        this.disableAsideSelfDisplay =
            this.layout.getProp('aside.self.display') === false;
        this.brandSkin = this.layout.getProp('brand.self.theme');
        this.headerLogo = this.getLogo();
        this.ulCSSClasses = this.layout.getProp('aside_menu_nav');
        this.asideMenuCSSClasses = this.layout.getStringCSSClasses('aside_menu');
        this.asideMenuHTMLAttributes = this.layout.getHTMLAttributes('aside_menu');
        this.asideMenuDropdown = this.layout.getProp('aside.menu.dropdown') ? '1' : '0';
        this.brandClasses = this.layout.getProp('brand');
        this.asideSelfMinimizeToggle = this.layout.getProp(
            'aside.self.minimize.toggle'
        );
        this.asideMenuScroll = this.layout.getProp('aside.menu.scroll') ? 1 : 0;
        // this.asideMenuCSSClasses = `${this.asideMenuCSSClasses} ${this.asideMenuScroll === 1 ? 'scroll my-4 ps ps--active-y' : ''}`;
        // Routing
        this.location = this.loc;
    }


    // Get User Data
    getUser() {
        const getCurrentUser = this.userRollsChecker.getCurrentUserData().subscribe(data => {
            this.userRolesList = data.roles;
        });

        // Add request to unsubscribe list
        this.unsubscribe.push(getCurrentUser);
    }


    private getLogo() {
        if (this.brandSkin === 'light') {
            return './assets/media/logo-grafinia-white.png';
        } else {
            return './assets/media/logo-grafinia-white.png';
        }
    }

    ngOnDestroy() {
        this.unsubscribe.forEach((sb: any) => sb.unsubscribe());
    }
}
